export default {
  'app.true': 'YA',
  'app.false': 'TIDAK',
  'app.403.page': 'Tidak ada izin',
  'app.403.page.tip': 'Silakan hubungi admin untuk izin',
};
